<script lang="ts">
  import { link, useLocation } from 'svelte-navigator';

  export let href: string;

  const location = useLocation();

  const applyLink = $location.pathname !== '/' && href !== '/' ? link : () => {};
</script>

<a {href} use:applyLink on:click on:keypress>
  <slot />
</a>

<style>
  a {
    user-select: none;
    color: inherit;
    padding: 0.5rem;
    text-decoration: none;
    margin: 0 auto;
    padding: 0;
  }

  a:focus {
    box-shadow: 0px var(--outline) 0px 0px var(--active);
    border: none;

    /* High-contrast */
    outline-color: transparent;
    outline-width: var(--outline-width);
    outline-style: dotted;
  }

  a:hover {
    transition: transform ease-in-out 100ms;
  }
</style>
